module.exports = __webpack_public_path__ + "static/img/sign_zero@2x.1bd0b3a1.png";